module.exports = __webpack_public_path__ + "static/media/nav-expand.2.500874ad.svg";